import { useParams } from 'react-router';

import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { Typography } from '@app-velocity/ui';

import { PathsSection } from '../PathsSection';

import { SinglePath } from '../../../../types';

import { CategoryIcon } from './components/CategoryIcon';

export type PathsCategoryProps = {
  categoryName: string;
  category?: {
    successful: SinglePath[];
    unsuccessful: SinglePath[];
  };
};

const StyledTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const StyledTitle = styled(Typography)({
  fontSize: 17,
  fontWeight: 700,
});

const LEGACY_PERSONAS = ['default', 'accessible'];

export const PathsCategory = ({
  category,
  categoryName,
}: PathsCategoryProps) => {
  const { t } = useI18n();
  const { type } = useParams<{
    type: 'human' | 'simulated';
  }>();

  if (!category || !type || !['human', 'simulated'].includes(type)) return null;

  const { successful, unsuccessful } = category;

  if (successful.length === 0 && unsuccessful.length === 0) return null;

  const samplePath = successful[0] || unsuccessful[0];

  const categoryTitle =
    samplePath?.personaLabel ??
    t(
      `prototypes:report.paths.category.${
        categoryName as 'default' | 'accessible'
      }`
    );

  const categoryIcon = LEGACY_PERSONAS.includes(categoryName)
    ? categoryName
    : 'default';

  return (
    <div>
      {type === 'simulated' ? (
        <StyledTitleContainer>
          <CategoryIcon category={categoryIcon as 'accessible' | 'default'} />
          <StyledTitle component="h3">{categoryTitle}</StyledTitle>
        </StyledTitleContainer>
      ) : null}
      {category.successful.length > 0 ? (
        <PathsSection
          paths={successful}
          title={t(`prototypes:report.paths.${type}.successful`, {
            count: successful.length,
          })}
          subtitle={t(`prototypes:report.paths.${type}.successful_text`)}
        />
      ) : null}
      {category.unsuccessful.length > 0 ? (
        <PathsSection
          indexOffset={successful.length}
          paths={unsuccessful}
          title={t(`prototypes:report.paths.${type}.unsuccessful`, {
            count: unsuccessful.length,
          })}
          subtitle={t(`prototypes:report.paths.${type}.unsuccessful_text`)}
        />
      ) : null}
    </div>
  );
};
